export default{get forceTouchAvailable(){return!1}};